import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { ReservationProvider } from "./components/ReservationModal";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Reservations from "./pages/Reservations";
import PrivateEvents from "./pages/PrivateEvents";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ReservationProvider>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/reservations" element={<Reservations />} />
              <Route path="/private-events" element={<PrivateEvents />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </ReservationProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
